import styled from "styled-components";
import { color } from "../../styles";

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const Input = styled.input<{ isError?: boolean }>`
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 10px;
    border: 1px solid ${(props) => (props.isError ? "#ff0000" : color.emphasis.NEUTRAL_N70)};
    border-radius: 5px;
    line-height: 24px;
    font-size: 13px;

    &:focus {
        outline: none;
        border-color: ${(props) => (props.isError ? "#ff0000" : color.primary.BLUE_B100)};
        box-shadow: 0 0 0 2px rgba(0, 88, 160, 0.12);
    }

    &::placeholder {
        color: ${color.secondary.DARK_GREY};
        font-size: 15px;
        font-style: normal;
        line-height: 22px;
        font-weight: 300;
    }

    &:disabled {
        opacity: 0.5;
    }
`;

export const DropdownContainer = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: ${color.emphasis.NEUTRAL_N0};
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 5px;
    z-index: 9999;
    margin-top: 6px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const DropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid ${color.emphasis.NEUTRAL_N10};
    background-color: ${color.emphasis.NEUTRAL_N0};
    transition: background-color 0.2s;
    &:hover {
        background-color: ${color.emphasis.NEUTRAL_N5};
    }
    &:last-child {
        border-bottom: none;
    }
    font-family: Noto Sans;
    font-size: 14px;
`;

export const DropdownItemLabel = styled.div`
    color: ${color.secondary.CHARCOAL};
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
`;

export const DropdownItemHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DropdownItemBadge = styled.span`
    flex-shrink: 0;
    color: ${color.primary.BLUE_B100};
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
`;

export const DropdownItemDescription = styled.div`
    margin-top: 2px;
    color: ${color.emphasis.NEUTRAL_N70};
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    white-space: normal;
    word-break: break-word;
`;
